<template>
    <div>
        <v-toolbar class="main">
            <button class="nav-back" @click="goBack"><v-icon>keyboard_arrow_left</v-icon> Välj konto</button>
        </v-toolbar>
        <div class="code-entry">
            <h1>Logga in</h1>
            <v-text-field type="text" class="rectangle-grey l-gg-till-konto" v-bind:placeholder="this.$store.state.activeProfile.username" readonly></v-text-field>
            <v-text-field id="codeInput" class="rectangle-white l-gg-till-konto" v-model="password" type="number" android:inputType="number" pattern="\d*" onkeypress='return event.charCode >= 48 && event.charCode <= 57' required autofocus></v-text-field> </br>
            <v-btn block color="primary" :disabled="$store.state.loggingIn" style="float:right" @click="login">Logga in</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            password:"",
            profile: {
                username: this.$store.state.activeProfile.username,
                password: ""
            }

        }
    },
    methods:{
        goBack(){
            this.$router.push('/');
        },
        login(){
            if (this.password != null) {
                this.profile.password = this.password;
                this.$store.commit('postProfile', this.profile);
            } else {
                window.alert("Lösenord krävs");
            }
        }
    },
    created: function(){
        this.$store.state.loggingIn = false;
    }
}
</script>

<style>
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Authenticate.vue